// removed by extract-text-webpack-plugin
module.exports = {"header":"_3M6gcfyzQcu-rjIC4eywCE","content":"EIQ0GnmMQ_5s4iVTCeWEe","md":"_1gf5vsZV1WmBJhRA8Ep9JA","accordion":"nf6YIoEfQqF_UYM6XFwV1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisAccordion.scss
// module id = 1229
// module chunks = 0